export default __webpack_public_path__ + "static/media/458.033c04ac.png";